<section class="container">
  <div class="header-wrapper">
    <h1>Matrices</h1>
  </div>
  <div class="content-wrapper">
    <table>
      <thead>
        <tr>
          <th>
            Name
          </th>
          <th>
            Edit Matrix
          </th>
          <th>
            Copy Matrix
          </th>
        </tr>
      </thead>
      @for (matrix of matrices; track matrix) {
        <tr>
          <td>
            {{matrix.Name}}
          </td>
          <td>
            <a [routerLink]="[matrix.Name]">Edit</a>
          </td>
          <td>
            <a [routerLink]="[matrix.Name, 'copy']">Copy as new</a>
          </td>
        </tr>
      }
    </table>
  </div>
</section>